import styled from 'styled-components';

export const StyledFooterPages = styled.div`
  [class*='MainContentWrapper'] {
    margin-left: 0;
    width: 100% !important;
  }
  [data-testid='test-error-page'] {
    height: calc(100vh - 48px) !important;
  }
`;
